import { render, staticRenderFns } from "./OtoTypography.vue?vue&type=template&id=2debbf2c&scoped=true"
import script from "./OtoTypography.vue?vue&type=script&lang=js"
export * from "./OtoTypography.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2debbf2c",
  null
  
)

export default component.exports